import { useMemo } from "react";

import { Connection } from "src/api/connectApi/types";
import { TableComp as Table } from "src/base-components/Table";
import { columns as tableColumns } from "src/connections/columns";

export const ConnectionList: React.FC<{
  connections: Connection[];
  onEdit: (id: string) => void;
  onDelete: (id: string) => void;
  onTest: (id: string) => void;
  testingConnection?: Connection;
  searchQuery?: string;
}> = ({
  onEdit,
  onDelete,
  onTest,
  testingConnection,
  connections,
  searchQuery,
}) => {
  const columns = useMemo(
    () =>
      tableColumns({
        onDelete,
        onEdit,
        onTest,
        testingConnection,
      }),
    [onDelete, onEdit, onTest, testingConnection],
  );
  return (
    <Table
      columns={columns}
      data={connections}
      globalFilter={searchQuery}
      rowClassName="cursor-pointer"
      rowPropsGetter={(rowData) => ({
        "data-loc": `connection-row-${rowData.original.name}-${rowData.original.id}}`,
        onClick: () => onEdit(rowData.original.id),
      })}
      clientSideFiltering
      disableVirtualization
    />
  );
};
